export default __webpack_public_path__ + "static/media/hsbc.1c127a88.svg";